import { Heading, Link } from '@chakra-ui/react';

export default function Navlink(props) {
    const { title, url } = props;
    return (
        <Heading size = "sm">
            <Link href = { url }>{ title }</Link>
        </Heading>
    );
};